// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"styles_modalHeader__2xAKv","modalBody":"styles_modalBody__2Vi64","title":"styles_title__3D0-Y"};